import { render, staticRenderFns } from "./IFormErrors.vue?vue&type=template&id=0d2a0388&"
import script from "./IFormErrors.vue?vue&type=script&lang=js&"
export * from "./IFormErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports